

export const TABLE_LOAD_TABLES = 'TABLE_LOAD_TABLES'
export const TABLE_LOAD_NEWS = 'TABLE_LOAD_NEWS'
export const TABLE_LOAD_SPONSORS = 'TABLE_LOAD_SPONSORS'
export const TABLE_LOAD_HELP = 'TABLE_LOAD_HELP'
export const TABLE_LOAD_NAB = 'TABLE_LOAD_NAB'
export const TABLE_LOAD_SPEAKERS = 'TABLE_LOAD_SPEAKERS'
export const TABLE_LOAD_SPEAKER = 'TABLE_LOAD_SPEAKER'
export const TABLE_LOAD_EVENT = 'TABLE_LOAD_EVENT'



export const loadTables = payload => ({
    type: TABLE_LOAD_TABLES,
    payload: payload
})

export const loadNews = payload1 => ({
    type: TABLE_LOAD_NEWS,
    payload: payload1
})

export const loadSponsors = payload2 => ({
    type: TABLE_LOAD_SPONSORS,
    payload: payload2
})


export const loadHlp = payload3 => ({
    type: TABLE_LOAD_HELP,
    payload: payload3
})


export const loadNab = payload4 => ({
    type: TABLE_LOAD_NAB,
    payload: payload4
})

export const loadSpeakers = payload5 => ({
    type: TABLE_LOAD_SPEAKERS,
    payload: payload5
})

export const inputSpeaker = payload6 => ({
    type: TABLE_LOAD_SPEAKER,
    payload: payload6
})

export const setEvent = payload7 => ({
    type: TABLE_LOAD_EVENT,
    payload: payload7
})